export const TransferRecipientTypeEnum = {
  Individual: 'Individual',
  Business: 'Business',
} as const;
export type TransferRecipientTypeEnum = (typeof TransferRecipientTypeEnum)[keyof typeof TransferRecipientTypeEnum];
